import { Input, InputProps } from '@chakra-ui/react'
import React, { forwardRef } from 'react'
import { InputStyle } from '~/components/defaults/componentStyles/Input.style'

export interface MangoInputProps extends Omit<InputProps, 'variant'> {
  variant?: 'mango' | 'webPhoneModal'
}

/**
 * MangoInput component that applies custom Mango variant styles directly.
 * In Chakra v3, custom variants need to be applied manually since they're not
 * automatically registered in the theme system.
 */
export const MangoInput = forwardRef<HTMLInputElement, MangoInputProps>(
  ({ variant = 'mango', ...props }, ref) => {
    // Get the custom styles for the specified variant
    const variantStyles = InputStyle.variants?.[variant]
    const customStyles =
      variantStyles &&
      typeof variantStyles === 'object' &&
      'field' in variantStyles
        ? variantStyles.field
        : {}

    return <Input ref={ref} {...customStyles} {...props} />
  },
)

MangoInput.displayName = 'MangoInput'
